import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ReactSVG } from 'react-svg';
import { replaceAll } from '../../../global/helpers/string-helpers';
import { setDioHovered, setMapFilter, setSelectedDio, setSelectedRegion } from '../clergy-comp-report-slice';
import { domesticMapSelection, handleInternationalDioClick, provHover } from '../map-actions';

export function InternationalMap() {

	const dispatch = useDispatch();
	useEffect(() => {
		return function cleanUp() {
			dispatch(setSelectedDio(null));
			dispatch(setSelectedRegion(null));
			dispatch(setMapFilter({ dio: null, region: null }));
			domesticMapSelection.currentDio = null;
			domesticMapSelection.currentRegion = null;

		};
	}, []);
	return (
		<ReactSVG
			src='/static/img/clergy-comp/international.svg'
			beforeInjection={(svg) => {
				const dios: ChildNode[] = [];
				svg.childNodes.forEach(a => {
					if (a.nodeName === 'g') dios.push(a);
				});
				dios.forEach(dio => {
					if ((dio as HTMLElement)?.getAttribute('id') !== 'background') {
						dio.addEventListener('click', () => handleInternationalDioClick(dio as HTMLElement, dios as HTMLElement[], dispatch));
						dio.addEventListener('mouseover', () => {
							provHover('0.7', dio as HTMLElement);
							dispatch(setDioHovered(replaceAll((dio as HTMLElement)?.getAttribute('id').replace('Dio_', ''), '_', ' ')));
						});
						dio.addEventListener('mouseout', () => {
							provHover('1', dio as HTMLElement);
							dispatch(setDioHovered(''));
						});
					}
				});
			}}
		/>
	);
}